import request from './request'

export function appointmentformSubmit(query) {
    return request({
        url: '/manager/customer/appointment/formSubmit',
        method: 'post',
        data: query
    })
}
export function appointmentsign(query) {
    return request({
        url: '/manager/customer/appointment/sign',
        method: 'post',
        data: query
    })
}

export function appointmentform(query) {
    return request({
        url: '/manager/customer/appointment/form',
        method: 'get',
        params: query
    })
}
export function weixincampus(query) {
    return request({
        url: '/weixin/campus',
        method: 'get',
        params: query
    })
}

export function weixinschoolgrade(query) {
    return request({
        url: '/weixin/school/grade',
        method: 'get',
        params: query
    })
}

export function weixinschools(query) {
    return request({
        url: '/weixin/schools',
        method: 'get',
        params: query
    })
}